import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import ButtonBlue from "../Button/ButtonBlue";
import DescriptionBlack from "../../common/images-new/description-black.svg";
import {
  addAttribute,
  htmlToText,
  trimString,
  tokenAuthorize,
} from "../Helpers/Common";
import { useDispatch, useSelector } from "react-redux";
import { getMyPosts } from "../../redux/actions/showcase";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../Helpers/Config";
import { staticFiles } from "../Helpers/Static";
import ModalRespondTask from "../../pages/Learning/ModalRespondTask";
import {
  ButtonCommonDelete,
  ButtonCommonGreen,
  ButtonCommonTop,
  ButtonCommonTopNew,
  Card,
  DivBadge,
  DivBadgeNew,
  TextGray,
} from "../../pages/Theme";
import moment from "moment";
import Swal from "sweetalert2";
import Button from "../Button/Button";
import ButtonGreen from "../Button/ButtonGreen";
import ActionButton from "../Button/ActionButton";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { MdDescription } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import RichContent from "../Editor/RichContent";

const FILE_UPLOAD = staticFiles.fileUpload;

const CardTaskDetail = ({
  data,
  completed,
  dueDate,
  toggleExpansion,
  ...props
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const myPosts = useSelector((state) => state.showcase.myPosts);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const [act, setAct] = useState(3);
  const [selected, setSelected] = useState([]);
  const [selected1, setSelected1] = useState([]);

  const [attachments, setAttachments] = useState([]);

  const [checked, setChecked] = useState(completed);

  const [showModal, setShowModal] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const sourceRef = useRef(null);
  const modalRef = useRef();
  const onClickRespond = () => {
    setSelected([]);
    setShowModal(true);
    dispatch(getMyPosts());
  };

  // useEffect(() => {
  //   setReadMore(toggleExpansion);
  // }, [toggleExpansion]);

  const markAsDone = () => {
    axios
      .post(serverUrl.LearningResponse + `/${data.id}`, {})
      .then((resp) => {
        if (resp.status === 200) {
          props.onPostUpdate && props.onPostUpdate();
          setAct(4);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  };

  const undoMark = () => {
    axios
      .delete(serverUrl.LearningResponse + `/${data.id}`, {})
      .then((resp) => {
        if (resp.status === 200) {
          props.onPostUpdate && props.onPostUpdate();
          setAct(3);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  };

  useLayoutEffect(() => {
    switch (data.action) {
      case 0:
        if (data.completed) setAct(4);
        else setAct(3);
        break;
      case 1:
        if (data.completed) setAct(2);
        else setAct(1);
        break;
      default:
        setAct(3);
        break;
    }
  }, [data]);

  const onAttachPost = (attachments) => {
    const attachmentIds = selected.map((item) => item.reflection_id);
    if (attachments.length > 0) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      sourceRef.current = source;
      const attachmentFormData = new FormData();
      // const imagePath = serverUrl.Base + resp.data.data.path

      attachments.forEach((file) => {
        attachmentFormData.append("file", file, file.name);
      });

      axios
        .post(serverUrl.UploadMultipleFiles, attachmentFormData, {
          headers: { "Content-Type": "multipart/form-data" },
          cancelToken: source.token,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted); // Use a state or variable to store progress
          },
        })
        .then((resp) => {
          const attachmentsdata = resp.data.map(
            (storedFile) => serverUrl.Base + storedFile.path
          );
          setUploadProgress(0);
          axios
            .post(serverUrl.LearningResponse + `/${data.id}`, {
              attachments: [],
              file_url: attachmentsdata,
            })
            .then((resp) => {
              if (resp.status === 200) {
                props.onPostUpdate && props.onPostUpdate();
                setAct(2);
                setShowModal(false);
              }
            });
        })
        .catch((err) => {
          console.log(err);
          tokenAuthorize(err?.response?.status);
          if (axios.isCancel(err)) {
            console.log(err);
          } else {
            console.error(err);
          }
          setUploadProgress(0);
          return null;
        })
        .finally(() => {
          sourceRef.current = null;
        });
    }
    if (attachmentIds.length > 0) {
      axios
        .post(serverUrl.LearningResponse + `/${data.id}`, {
          attachments: attachmentIds,
          file_url: [],
        })
        .then((resp) => {
          if (resp.status === 200) {
            props.onPostUpdate && props.onPostUpdate();
            setAct(2);
            setShowModal(false);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
        });
    }
  };

  const undoattachConfirm = () => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      html: `Are you sure you want to undo this task?<br><span style="color:red;">All submissions will be removed.</span>`,
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        undoAttachPost();
      }
    });
  };

  const undoAttachPost = () => {
    axios
      .delete(serverUrl.LearningResponse + `/${data.id}`, {})
      .then((resp) => {
        if (resp.status === 200) {
          props.onPostUpdate && props.onPostUpdate();
          setAct(1);
          Swal.fire({
            heightAuto: false,
            title: "Success",
            text: "Undo successful.",
            icon: "success",
          });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  };
  const currentDate = new Date().toJSON().slice(0, 10);
  const due = moment(dueDate).format("DD/MM/YYYY").split("/");
  const newDate = `${due[2]}-${due[1]}-${due[0]}`;
  const showError = () => {
    Swal.fire({
      heightAuto: false,
      title: "Information",
      text: "The deadline for this task has passed. kindly consult with your tutor for further guidance or to discuss possible extensions.",
      icon: "info",
    });
  };

  const handleCancelUpload = () => {
    sourceRef.current.cancel("Upload canceled by user");
    sourceRef.current = null;
    setUploadProgress(0);
  };

  return (
    <Card className="relative w-full flex flex-col border20px shadow-sm p-3 md:p-5 md:px-5 cardBackgroundColor  px-3 text-sm">
      <ModalRespondTask
        show={showModal}
        handleClose={() => setShowModal(false)}
        posts={myPosts}
        // attachPost={() => onAttachPost()}
        selectedPost={selected}
        setSelectedPost={setSelected}
        taskId={data.id}
        attachPost={(data) => onAttachPost(data)}
      // selectedPost1={selected1}
      // setSelectedPost1={setSelected1}
      />
      <div
        className={`${uploadProgress > 0 && uploadProgress < 100 ? "flex" : "hidden "
          } fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block z9999`}
        onClick={(e) => e.stopPropagation()}
      >
        <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 w-full md:w-3/12">
          <Card className="h-2/4 rounded-lg overflow-hidden" id="cards">
            <div className="relative flex py-3">
              <div className="w-full font-bold flex items-start px-5">
                File Uploading In-progress
              </div>
            </div>
            <hr className="text-gray-200" />
            <div
              className="overflow-y-auto h-52 w-full scroll-smooth"
              ref={modalRef}
            >
              <div className="w-full h-1/2 flex items-center justify-center">
                <div className="w-1/2">
                  <Progress percent={uploadProgress} status="active" />
                </div>
              </div>
              <div className="w-full h-1/2 flex items-center justify-center">
                <ActionButton
                  className={"py-3 px-4 h-10"}
                  buttonStyle="w-full"
                  textStyle=""
                  style="px-4 py-4"
                  title="Cancel Uploads"
                  width="full"
                  onClick={() => handleCancelUpload()}
                />
              </div>
            </div>
          </Card>
        </section>
      </div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-lg blackColor font-semibold ">{data.name}</span>
        <div className="flex items-center">
          {act === 1 && (
            <ButtonCommonTopNew
              className={
                newDate < currentDate
                  ? "cursor-not-allowed px-5 py-2 rounded-lg text-sm"
                  : "cursor-pointer px-5 py-2 rounded-lg text-sm"
              }
              onClick={
                newDate < currentDate
                  ? () => {
                    showError();
                  }
                  : () => onClickRespond()
              }
            >
              Respond
            </ButtonCommonTopNew>
          )}
          {act === 2 && (
            <div className="flex flex-col-reverse lg:flex-row lg:space-x-10 items-center">
              <div className="flex flex-row lg:flex-col checkGreen undoCheck">
                {/* {isDefaultTheme == false ? (
                  <label class={`${"container-check"}`}>
                    <input type="checkbox" checked={true} readOnly={true} />
                    <span
                      class={`${"checkmark"} ${
                        newDate < currentDate
                          ? `cursor-not-allowed`
                          : `cursor-pointer`
                      }`}
                    ></span>
                  </label>
                ) : (
                  <>
                    <input
                      type="checkbox"
                      className={
                        `opacity-0 absolute self-center h-10 w-10 ` +
                        (newDate < currentDate
                          ? `cursor-not-allowed`
                          : `cursor-pointer`)
                      }
                      checked={true}
                      readOnly={true}
                      style={{
                        position: "fixed",
                        cursor:
                          newDate < currentDate ? `not-allowed` : `pointer`,
                      }}
                    />
                    <div
                      className="box bg-gray border rounded border-gray-400 w-10 h-10 flex justify-center items-center mr-3 lg:mr-0"
                      style={{
                        cursor:
                          newDate < currentDate ? `not-allowed` : `pointer`,
                      }}
                    >
                      <svg
                        className="mark fill-current hidden w-4 h-4 text-white pointer-events-none"
                        viewBox="0 0 20 20"
                      >
                        <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                      </svg>
                    </div>
                  </>
                )} */}
                <ButtonCommonDelete
                  onClick={
                    !(newDate < currentDate) ? undoattachConfirm : showError
                  }
                  className={`px-5 py-2 text-sm rounded-lg ${newDate < currentDate
                    ? `cursor-not-allowed`
                    : `cursor-pointer`
                    }`}
                >
                  Undo
                </ButtonCommonDelete>
              </div>
            </div>
          )}
          {act === 3 && (
            <ButtonCommonTopNew
              onClick={!(newDate < currentDate) ? markAsDone : showError}
              className={`px-5 py-2 text-sm rounded-lg ${newDate < currentDate ? `cursor-not-allowed` : `cursor-pointer`
                }`}
            >
              Mark as done
            </ButtonCommonTopNew>
          )}
          {act === 4 && (
            <div className="flex flex-col checkGreen undoCheck">
              <ButtonCommonDelete
                onClick={!(newDate < currentDate) ? undoMark : showError}
                className={`px-5 py-2 text-sm rounded-lg ${newDate < currentDate
                  ? `cursor-not-allowed`
                  : `cursor-pointer`
                  }`}
              >
                Undo
              </ButtonCommonDelete>
            </div>
          )}
        </div>
      </div>
      <div className="flex">
        <div className="flex flex-col w-full">
          {act == 2 && (
            <div className="mb-3 mt-1 flex w-full flex-wrap gap-1.5 backGroundColor p-4 shadow-sm rounded-xl borderGray">
              <span className="text-md blackColor w-full font-semibold mb-1">
                Submission
              </span>
              {data &&
                data.attachments &&
                data.attachments.map((post, index) => (
                  <>
                    <Tooltip
                      title={post.reflection_title ?? ""}
                      placement="top"
                      arrow
                    >
                      <DivBadgeNew
                        key={index}
                        className="flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                        onClick={() =>
                          history.push(
                            `/post/${post && post.reflection_id
                              ? post.reflection_id
                              : null
                            }`,
                            { src: "/tasks" }
                          )
                        }
                      >
                        <MdDescription className="w-5 h-5 primaryIcon" />
                        <span
                          rel="noopener noreferrer"
                          className="flex text-sm p-1 nav-navigate"
                        >
                          <div className="">
                            {trimString(
                              post && post.reflection_title
                                ? post.reflection_title
                                : "Deleted post",
                              55
                            )}
                          </div>
                        </span>
                      </DivBadgeNew>
                    </Tooltip>
                  </>
                ))}
              {data &&
                data.fileurl &&
                data.fileurl?.map((post, index) => {
                  let itemName = post;
                  if (itemName) {
                    const lastSlash = itemName.lastIndexOf("/");

                    if (lastSlash !== -1) {
                      itemName = itemName.substr(
                        lastSlash + 1,
                        itemName.length - lastSlash - 1
                      );
                      itemName = itemName.includes("-")
                        ? itemName.substring(itemName.indexOf("-") + 1)
                        : itemName;
                    }

                    return (
                      <>
                        <DivBadge
                          key={index}
                          className="flex flex-row items-center rounded-lg px-2 justify-center w-max"
                        >
                          <MdDescription className="w-5 h-5 text-white" />
                          <a
                            href={post}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex text-sm p-1 nav-navigate"
                          >
                            <div className=" text-white">{itemName}</div>
                          </a>
                        </DivBadge>
                      </>
                    );
                  }
                  return null;
                })}
            </div>
          )}
          {/* {data.detail.length > 120 ? (
            readMore === false ? (
              <div>
                <div className=" break-words break-anywhere">
                  {trimString(htmlToText(data.detail), 300)}
                </div>
                <div className="flex md:justify-end">
                  <span
                    className=" mb-0  blueColor hover:opacity-80 cursor-pointer"
                    onClick={() => setReadMore(true)}
                  >
                    Read more
                  </span>
                </div>
              </div>
            ) : (
              <div>
                <div
                  className="text-viewer break-words break-anywhere"
                  style={{ fontSize: "revert" }}
                  dangerouslySetInnerHTML={{
                    __html: addAttribute(data.detail),
                  }}
                ></div>
                <div className="flex md:justify-end">
                  <span
                    className="mb-0 blueColor hover:opacity-80 cursor-pointer"
                    onClick={() => setReadMore(false)}
                  >
                    Read less
                  </span>
                </div>
              </div>
            )
          ) : (
            <div className="break-words">
              {trimString(htmlToText(data.detail), 350)}
            </div>
          )} */}
          <div>
            <RichContent
              className=""

              content={addAttribute(data.detail)}
            />
            {/* <div className="flex md:justify-end">
              <span
                className="mb-0 blueColor hover:opacity-80 cursor-pointer"
                onClick={() => setReadMore(false)}
              >
                Read less
              </span>
            </div> */}
          </div>
        </div>
      </div>

      {/* <div
        className={
          act === 2
            ? "w-3/6 md:w-2/5 flex flex-wrap content-center justify-center"
            : `w-2/5 md:w-1/5 flex flex-wrap content-center justify-center`
        }
      >
        {act === 1 && (
          <ButtonBlue
            title="RESPOND"
            width="40"
            className={newDate < currentDate ? "cursor-not-allowed" : ""}
            onClick={
              newDate < currentDate
                ? () => {
                    showError();
                  }
                : () => onClickRespond()
            }
          />
        )}
        {act === 2 && (
          <div className="flex flex-col-reverse lg:flex-row lg:space-x-10 items-center">
            <div className="flex flex-col">
              {data &&
                data.attachments &&
                data.attachments.map((post, index) => (
                  <div
                    key={index}
                    className="flex flex-row items-center space-x-2 mt-2 lg:mt-0"
                  >
                    <img src={FILE_UPLOAD} alt="file upload" />
                    <TextGray
                      className="hover:opacity-80 cursor-pointer underline break-words w-32"
                      onClick={() =>
                        history.push(
                          `/post/${
                            post && post.reflection_id
                              ? post.reflection_id
                              : null
                          }`,
                          { src: "/tasks" }
                        )
                      }
                    >
                      {trimString(
                        post && post.reflection_title
                          ? post.reflection_title
                          : "DELETED POST",
                        25
                      )}
                    </TextGray>
                  </div>
                ))}
              {data &&
                data.fileurl &&
                data.fileurl?.map((post, index) => (
                  <div
                    key={index}
                    className="flex flex-row items-center space-x-2 mt-2 lg:mt-0"
                  >
                    <img src={FILE_UPLOAD} alt="file upload" />
                    <TextGray className="hover:opacity-80 cursor-pointer underline break-words w-32">
                      <a
                        href={post}
                        style={{ color: "#9ca3af" }}
                        target="_blank"
                        className="nav-navigate"
                      >
                        <TextGray>{post?.split("-")[1]}</TextGray>
                      </a>
                    </TextGray>
                  </div>
                ))}
            </div>
            <div className="flex flex-row lg:flex-col checkGreen undoCheck">
              {isDefaultTheme == false ? (
                <label class={`${"container-check"}`}>
                  <input type="checkbox" checked={true} readOnly={true} />
                  <span
                    class={`${"checkmark"} ${
                      newDate < currentDate
                        ? `cursor-not-allowed`
                        : `cursor-pointer`
                    }`}
                  ></span>
                </label>
              ) : (
                <>
                  <input
                    type="checkbox"
                    className={
                      `opacity-0 absolute self-center h-10 w-10 ` +
                      (newDate < currentDate
                        ? `cursor-not-allowed`
                        : `cursor-pointer`)
                    }
                    checked={true}
                    readOnly={true}
                    style={{
                      position: "fixed",
                      cursor: newDate < currentDate ? `not-allowed` : `pointer`,
                    }}
                  />
                  <div
                    className="box bg-gray border rounded border-gray-400 w-10 h-10 flex justify-center items-center mr-3 lg:mr-0"
                    style={{
                      cursor: newDate < currentDate ? `not-allowed` : `pointer`,
                    }}
                  >
                    <svg
                      className="mark fill-current hidden w-4 h-4 text-white pointer-events-none"
                      viewBox="0 0 20 20"
                    >
                      <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                    </svg>
                  </div>
                </>
              )}
              <TextGray
                className={` ${
                  isDefaultTheme == false ? "mt-9" : "mt-2"
                } ${`whitespace-nowrap hover:opacity-80`}`}
                onClick={!(newDate < currentDate) ? undoAttachPost : showError}
              >
                <p
                  className={
                    newDate < currentDate ? `cursor-auto` : `cursor-pointer`
                  }
                >
                  Undo
                </p>
              </TextGray>
            </div>
          </div>
        )}
        {act === 3 && (
          <ButtonGreen
            title="MARK AS DONE"
            width="40"
            onClick={!(newDate < currentDate) ? markAsDone : showError}
            className={
              newDate < currentDate
                ? "cursor-not-allowed border-2 px-10"
                : "border-2 px-10"
            }
            textStyle={"whitespace-nowrap"}
          />
        )}
        {act === 4 && (
          <div className="flex flex-col checkGreen undoCheck">
            {isDefaultTheme == false ? (
              <label class={`${"container-check"}`}>
                <input type="checkbox" checked={true} readOnly={true} />
                <span
                  class={`${"checkmark"} ${
                    newDate < currentDate
                      ? `cursor-not-allowed`
                      : `cursor-pointer`
                  }`}
                ></span>
              </label>
            ) : (
              <>
                <input
                  type="checkbox"
                  className={
                    `opacity-0 absolute self-center h-10 w-10 ` +
                    (newDate < currentDate
                      ? `cursor-not-allowed`
                      : `cursor-pointer`)
                  }
                  checked={true}
                  readOnly={true}
                  style={{
                    position: "fixed",
                    cursor: newDate < currentDate ? `not-allowed` : `pointer`,
                  }}
                />
                <div
                  className="box bg-gray border rounded border-gray-400 w-10 h-10 flex justify-center items-center"
                  style={{
                    cursor: newDate < currentDate ? `not-allowed` : `pointer`,
                  }}
                >
                  <svg
                    className="mark fill-current hidden w-4 h-4 text-white pointer-events-none"
                    viewBox="0 0 20 20"
                  >
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
              </>
            )}

            <TextGray
              className={`${
                isDefaultTheme == false ? "mt-9" : "mt-2"
              } ${`whitespace-nowrap mt-2 hover:opacity-80`}`}
              onClick={!(newDate < currentDate) ? undoMark : showError}
            >
              <p
                className={
                  newDate < currentDate ? `cursor-auto` : `cursor-pointer`
                }
              >
                Undo
              </p>
            </TextGray>
          </div>
        )}
      </div> */}

      {/* Post Link and checkbox */}
      {/* <div className='w-3/6 flex flex-wrap content-center justify-center'>
        <div className="flex flex-col-reverse lg:flex-row lg:space-x-10 items-center">
           <div className="flex flex-row items-center space-x-2 mt-2 lg:mt-0">
             <img src={DescriptionBlack} alt="description" />
             <a className="text-gray-500 whitespace-nowrap cursor-pointer">Example post 1</a>
           </div>
           <div className="flex flex-row lg:flex-col">
             <input type="checkbox" className="opacity-0 absolute self-center h-10 w-10 cursor-pointer" checked={completed} />
             <div className='box bg-gray border rounded border-gray-400 w-10 h-10 flex justify-center items-center mr-3 lg:mr-0'>
               <svg className="mark fill-current hidden w-4 h-4 text-white pointer-events-none" viewBox="0 0 20 20">
                 <path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/>
               </svg>
             </div>
             <a 
                className="text-gray-500 whitespace-nowrap mt-2 cursor-pointer"
                onClick={() => setChecked(false)}
              >
              Undo
              </a>
            </div>
            
          </div>
      </div> */}
    </Card>
  );
};

export default CardTaskDetail;
